<template>
  <div class="my-zone">
    <div class="container">
      <el-row :gutter="20">
        <el-col :span="4" :offset="0">
          <div class="left-nav">
            <div :class="[active === index?'active':'','nav-item']" v-for="(item, index) in navList" :key="index" @click="active=index">{{item}}</div>
          </div>
        </el-col>
        <el-col :span="20" :offset="0">
          <div class="nav-title">
            {{navList[active]}}
          </div>
          <div>
            <div v-show="active===0" class="member-wrap">
              <div class="list-item">会员登记：高级会员</div>
              <div class="list-item">用户名：超级管理员</div>
              <div class="list-item">姓名：待登记</div>
              <div class="list-item">联系电话：待设定</div>
              <div class="list-item">联系地址：待完善</div>
            </div>
            <div v-show="active===1" class="favorite">
              <div>您的收藏夹中没有任何产品。</div>
              <div>购物时只需点击“添加到心愿单”即可将其保存在此处。</div>
            </div>
            <div v-show="active===2" class="orders">
              <div>您没有任何历史订单。</div>
            </div>
            <div v-show="active===3" class="goods">
              <div>您没有购买过任何产品。</div>
            </div>
            <div v-show="active===4" class="setting">
              <UpdatePassword />
            </div>
            <div v-show="active===5" class="service">
              <div>客户服务热线</div>
              <div><i class="el-icon-service"></i> 028-86530702</div>
              <div style="padding-bottom:20px"></div>
              <div>服务时间</div>
              <div>周一至周五9:00-18:00（法定假日除外）</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import UpdatePassword from '@/components/UpdatePassword.vue'
export default {
  components: {
    UpdatePassword
  },
  data () {
    return {
      active: 0,
      navList: ['我的账户', '我的收藏', '我的订单', '历史产品', '设置', '客户服务'],
      form: {}
    }
  }
}
</script>

<style scoped>
.my-zone{
  box-sizing: border-box;
  padding: 100px 15px;
}
.container{
  max-width: 1200px;
  margin: 0 auto;
}
.nav-item{
  box-sizing: border-box;
  padding: 20px;
  cursor: pointer;
}
.active{
  font-weight: 600;
}
.nav-title{
  width: 100%;
  font-size: 30px;
  font-weight: 300;
  padding-bottom: 16px;
  border-bottom: 1px solid #333;
  color: #606266;
}
.member-wrap{
  margin-top: 50px;
  background-color: #F1F1F1;
  padding: 20px;
  font-size: 16px;
}
.list-item{
  padding: 10px;
}
.favorite,.orders,.goods,.setting,.service{
  padding: 30px 0;
  line-height: 30px;
  font-weight: 300;
}

</style>
